"use client";

import { Fragment } from "react";
import { Heading, Text } from "@pamperedchef/design-system";
import type { StepItem } from "@/composites/landing/types";
import { StepConnector } from "./StepConnector";
import * as styles from "./Steps.module.scss";

export interface StepsProps {
	steps: StepItem[];
}

/**
 * Numbered step cards in a horizontal row (desktop) with curved connectors.
 * Falls back to the 1-based index when a step omits its own `step_number`.
 * Presentational, props-in.
 */
export function Steps({ steps }: StepsProps) {
	if (!steps.length) return null;

	return (
		<ol className={styles["steps"]} data-component="Steps">
			{steps.map((step, i) => (
				<Fragment key={`${step.title}-${i}`}>
					<li
						className={styles["steps__item"]}
						data-step-index={i + 1}
					>
						<span
							className={styles["steps__number"]}
							aria-hidden="true"
						>
							{step.step_number ?? i + 1}
						</span>
						<div className={styles["steps__content"]}>
							<Heading
								tag="h3"
								styledAs="h5"
								className={styles["steps__title"]}
							>
								{step.title}
							</Heading>
							{step.body ? (
								<Text
									tag="p"
									styledAs="smr"
									className={styles["steps__copy"]}
								>
									{step.body}
								</Text>
							) : null}
						</div>
					</li>
					{i < steps.length - 1 ? (
						<li
							className={styles["steps__arrow"]}
							aria-hidden="true"
						>
							<StepConnector />
						</li>
					) : null}
				</Fragment>
			))}
		</ol>
	);
}
